import { CASE_SET_FILE_AI_READY } from './constants';
import { replaceItemImmutable } from 'utils/arrays';

export const setFileAiReady = ({ fileId, folderFileId }) => ({
  type: CASE_SET_FILE_AI_READY,
  payload: { fileId, folderFileId },
});

const updateCollection = (collection, matcher) => {
  if (!Array.isArray(collection) || collection.length === 0) {
    return collection;
  }

  const index = collection.findIndex(matcher);
  if (index === -1) {
    return collection;
  }

  const currentItem = collection[index];
  if (!currentItem || currentItem.aiNotReady === false) {
    return collection;
  }

  return replaceItemImmutable(
    collection,
    {
      ...currentItem,
      aiNotReady: false,
    },
    index,
  );
};

const updateSingleItem = (item, matcher) => {
  if (!item || !matcher(item)) {
    return item;
  }

  if (item.aiNotReady === false) {
    return item;
  }

  return {
    ...item,
    aiNotReady: false,
  };
};

export function reducer(state, action) {
  if (action.type !== CASE_SET_FILE_AI_READY) {
    return state;
  }

  const {
    payload: { fileId, folderFileId },
  } = action;

  if (fileId === null || typeof fileId === 'undefined') {
    return state;
  }

  const matcher = (item) => {
    if (!item) {
      return false;
    }
    if (item.id === fileId) {
      return true;
    }
    if (typeof folderFileId !== 'undefined' && folderFileId !== null) {
      return item.folderFileId === folderFileId || item.id === folderFileId;
    }
    return false;
  };

  return {
    ...state,
    documents: updateCollection(state.documents, matcher),
    ...(state.filteredAndSortedData && {
      filteredAndSortedData: updateCollection(state.filteredAndSortedData, matcher),
    }),
    ...(state.currentSelectedFile && matcher(state.currentSelectedFile) && {
      currentSelectedFile: updateSingleItem(state.currentSelectedFile, matcher),
    }),
    ...(state.lastSelectedFile && matcher(state.lastSelectedFile) && {
      lastSelectedFile: updateSingleItem(state.lastSelectedFile, matcher),
    }),
    ...(state.fileToCompare && matcher(state.fileToCompare) && {
      fileToCompare: updateSingleItem(state.fileToCompare, matcher),
    }),
  };
}
